/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { CollapsibleNavigationListProps } from './CollapsibleNavigationList';

export type CollapsibleNavigationListContextProps<K extends string | number> = Pick<
  CollapsibleNavigationListProps<K>,
  'selection' | 'expandedKeys' | 'onSelect' | 'onToggle' | 'edge'
> & {
  showFocusRing?: boolean;
  currentKey: K | undefined;
  navigationListItemPrefix?: string;
};

/**
 * Context used to pass TabBar information without having to pass it to TabBar children props.
 * We want to communicate information down to any interested TabBar item children.
 */

const CollapsibleNavigationListContext = createContext<
  CollapsibleNavigationListContextProps<string | number>
>(null!);

export { CollapsibleNavigationListContext };
